import * as THREE from 'three';

// Single instance: Created once on import
export const defaultMaterial = new THREE.MeshBasicMaterial({
  color: 0xcccccc, // Neutral gray
  wireframe: true, // Optional: Shows structure while loading
  transparent: true,
  opacity: 0.5,
});